import styled from 'styled-components';
import boxShadow from '../../configs/boxShadow';
import color from '../../configs/color';

const Wrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .ant-btn {
    min-width: 172px;
  }

  .component_search_component_btn_wrapper {
    position: relative;
    display: inline-flex;
    column-gap: 8px;
  }

  .component_search_component_sub_btn_wrapper {
    border: 1px solid ${color.grey2};
    box-shadow: ${boxShadow.normal};
    border-radius: 12px;
    background: ${color.grey5};
    width: 210px;
    position: absolute;
    right: 16px;
    top: 16px;
    z-index: 10;
    overflow: hidden;
  }
`;

export const SubButton = styled.div`
  color: ${color.black2};
  padding: 20px 17px;
  cursor: pointer;

  .anticon {
    margin-right: 13.6px;
  }

  &:hover {
    background: ${color.grey4};
  }

  &:not(:last-child) {
    border-bottom: 1px solid ${color.grey2};
  }
`;

export const FilterWrapper = styled.div`
  display: flex;
  align-items: center;
  width: ${(props) => {
    if (props.fullWidthSearch && !props.isShowFilter) {
      return '100%';
    }

    return '85%';
  }};

  .ant-input {
    padding: 12px 16px;
    border-radius: 12px;
    margin-right: 16px;
    border-color: ${(props) => {
      return props.withBorder ? `${color.grey1}` : `${color.white}`;
    }};
    box-shadow: ${(props) => {
      return !props.withBorder && `${boxShadow.normal}`;
    }};
    height: 44px;
    :focus {
      border-color: ${color.green5};
    }
  }

  .ant-select-selector {
    min-width: 156px;
    border-color: ${(props) => {
      return props.withBorder
        ? `${color.grey1} !important`
        : `${color.white} !important`;
    }};
    box-shadow: ${(props) => {
      return !props.withBorder && `${boxShadow.normal}`;
    }};
  }

  .ant-input-search.ant-input-group-wrapper {
    max-width: 300px;
    margin-right: 16px;
  }

  & > .ant-select:nth-child(2) {
    max-width: 200px;
    width: 100%;
    margin-right: 16px;
  }

  & > .ant-select:not(:nth-child(2)) {
    width: 100%;
    max-width: 180px;
  }

  .component_filter_component_select_wrapper {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 12px;
    height: 100%;

    .ant-select-single .ant-select-selector .ant-select-selection-item,
    .ant-select-single .ant-select-selector .ant-select-selection-placeholder,
    .ant-select-single:not(.ant-select-customize-input) .ant-select-selector,
    .ant-select-single:not(.ant-select-customize-input)
      .ant-select-selector
      .ant-select-selection-search-input,
    .ant-select-single .ant-select-selector .ant-select-selection-item,
    .ant-select-single .ant-select-selector .ant-select-selection-placeholder {
      height: 44px;
    }

    .ant-select-single .ant-select-selector .ant-select-selection-item,
    .ant-select-single .ant-select-selector .ant-select-selection-placeholder {
      line-height: 44px;
    }

    .ant-select-selector {
      border-radius: 12px;
    }
  }

  .ant-select-selector {
    padding: 12px 16px;
  }

  .ant-picker.ant-picker-range {
    border-radius: 12px;
    width: 360px;
    border-color: ${(props) => {
      return props.withBorder
        ? `${color.grey1} !important`
        : `${color.white} !important`;
    }};
    box-shadow: ${(props) => {
      return !props.withBorder && `${boxShadow.normal}`;
    }};
    height: 44px;
  }

  .component_filter_component_additional_component {
    position: absolute;
    right: 0;
  }
`;

export default Wrapper;
